import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useCallback, useMemo, useState } from "react";
import { useFolderTree } from "@devowl-wp/react-folder-tree";
import { AppTreeBodyContent } from "./appTreeBodyContent.js";
import { AppTreeControllerProvider } from "../../contexts/appTreeControllerContext.js";
import { AppTreeLocalStateProvider } from "../../contexts/appTreeLocalStateContext.js";
import { useToolbarState } from "../../hooks/tree/toolbar/useToolbarState.js";
import { getDefaultFolder } from "../../integrations/defaultFolder.js";
import { useStores } from "../../store/rootStore.js";
const AppTreeBody = observer(({ id, attachmentsBrowser, isModal = false, children, callbacksRef, onUiBundleChange })=>{
    const { treeStore } = useStores();
    const { set, isTreeLinkDisabled } = useFolderTree();
    const { selected, rootId } = treeStore;
    const [isMoveable, setIsMoveable] = useState(true);
    const [isWPAttachmentsSortMode, setIsWPAttachmentsSortMode] = useState(false);
    const [rearrangeBoxId, setRearrangeBoxId] = useState(false);
    const [showProFeature, setShowProFeature] = useState();
    const selectedId = getDefaultFolder();
    const defaultInitialSelectedId = !selectedId || selectedId === "all" ? "all" : +selectedId;
    const [resolvedInitialSelectedId, setResolvedInitialSelectedId] = useState(defaultInitialSelectedId);
    const { lockedVisible, lockedToolTipText } = useToolbarState(isWPAttachmentsSortMode, selected, rootId, false);
    const controllerState = useMemo(()=>({
            isMoveable,
            isWPAttachmentsSortMode,
            isTreeLinkDisabled,
            currentFolderRestrictions: [],
            toolbar_locked: {
                visible: lockedVisible,
                toolTipText: lockedToolTipText
            },
            showProFeature,
            rearrangeBoxId
        }), [
        isMoveable,
        isWPAttachmentsSortMode,
        isTreeLinkDisabled,
        lockedVisible,
        lockedToolTipText,
        showProFeature,
        rearrangeBoxId
    ]);
    const setStatePatch = useCallback((patch)=>{
        if ("isMoveable" in patch && patch.isMoveable !== undefined) {
            setIsMoveable(patch.isMoveable);
        }
        if ("isWPAttachmentsSortMode" in patch && patch.isWPAttachmentsSortMode !== undefined) {
            setIsWPAttachmentsSortMode(patch.isWPAttachmentsSortMode);
        }
        if ("isTreeLinkDisabled" in patch && patch.isTreeLinkDisabled !== undefined) {
            set({
                isTreeLinkDisabled: patch.isTreeLinkDisabled
            });
        }
        if ("showProFeature" in patch) {
            setShowProFeature(patch.showProFeature);
        }
        if ("rearrangeBoxId" in patch) {
            setRearrangeBoxId(patch.rearrangeBoxId);
        }
    }, [
        set
    ]);
    const localState = useMemo(()=>({
            isMoveable,
            setIsMoveable,
            isWPAttachmentsSortMode,
            setIsWPAttachmentsSortMode,
            showProFeature,
            setShowProFeature,
            rearrangeBoxId,
            setRearrangeBoxId,
            resolvedInitialSelectedId,
            setResolvedInitialSelectedId,
            controllerState,
            setStatePatch
        }), [
        isMoveable,
        isWPAttachmentsSortMode,
        showProFeature,
        rearrangeBoxId,
        resolvedInitialSelectedId,
        controllerState,
        setStatePatch
    ]);
    return /*#__PURE__*/ _jsx(AppTreeControllerProvider, {
        children: /*#__PURE__*/ _jsx(AppTreeLocalStateProvider, {
            value: localState,
            children: /*#__PURE__*/ _jsx(AppTreeBodyContent, {
                id: id,
                attachmentsBrowser: attachmentsBrowser,
                isModal: isModal,
                callbacksRef: callbacksRef,
                onUiBundleChange: onUiBundleChange,
                localState: localState,
                children: children
            })
        })
    });
});
export { AppTreeBody };
